import { DndProvider } from "react-dnd";
import { ElementStore, ReactFormBuilder, Registry } from "react-form-builder2"
import { HTML5Backend } from 'react-dnd-html5-backend'
import 'react-form-builder2/dist/app.css';
import { forwardRef, useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import _ from "lodash";

import Loader from "../Loader/Loader";
import { SessionKeys } from "../../utils/AppUtils";
import CONFIG from "../../utils/config";
import { getSurvey, getSurveyClear, showSurvey, showSurveyClear } from "../../redux/learningPath/actions";
// import FormElementsEdit from "./FormBuilderEdit";
import "./FormBuilder.scss";
const InputText = forwardRef((props, ref) => {
    const { name, defaultValue, disabled } = props;
    return <input ref={ref} name={name} defaultValue={defaultValue} disabled={disabled} />;
});
Registry.register('InputText', InputText);

const FormBuilderSection = ({isMobile}) => {

    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false)
    const [formJSON, setFormJSON] = useState([]);
    const [enableBtn, setEnableBtn] = useState(false)
    const [infoModal, setInfoModal] = useState(false)
    const [showInfoModalMsg, setShowInfoModalMsg] = useState("");
    const [surveyTitle, setSurveyTitle] = useState("");
    const [items,] = useState([
        {key: 'Dropdown'},{key: 'Checkboxes'},
        {key: 'TextInput'},{key: 'TextArea'},
        {key: 'Rating'},{key: 'Range'},
        {key: 'RadioButtons'},{key: 'NumberInput'},
        {
            // group_name: 'Custom Element',
            key: 'InputText',
            element: 'CustomElement',
            component: InputText,
            type: 'custom',
            forwardRef: true,
            bare: true,
            field_name: 'my_input_',
            name: 'My Input',
            icon: 'fa fa-cog',
            props: { test: 'test_input' },
            label: 'Label Input',
        },
    ])

     const createSurveyData = useSelector(state => state.learningPath.surveyListing);
     console.log("createSurveyData",createSurveyData)

    useEffect(() => {
        console.log('FORM IS UPDATED')
        addLinkFontAwesome();
        // window.addEventListener('message', handleSubmitData);
    }, [dispatch])

    useEffect(() => {
        ElementStore.subscribe(state => {
            console.log("state",state.data);
            setFormJSON(state.data)
        })
    }, [])

    useEffect(() => {
       
        if (!_.isEmpty(formJSON) && surveyTitle.trim() !== "") {
            setEnableBtn(true);
        } else {
            setEnableBtn(false);
        }
    }, [formJSON, surveyTitle]);
    

    useEffect(() => {
      console.log("createSurveyData", createSurveyData);

      if (!_.isEmpty(createSurveyData)) {
        if (createSurveyData?.status === "success") {
          setShowInfoModalMsg(createSurveyData?.payload?.message);
          setInfoModal(true);
           setSurveyTitle("")
        //   setFormJSON([])
        ElementStore.dispatch({ type: 'set_data', data: [] });
        window.location.reload();
        dispatch(getSurveyClear({}))
        
          
        } else {
          console.log("inside if fifth ");
          setShowInfoModalMsg("something went wrong");
          setInfoModal(true);
          setSurveyTitle("")
        //   setFormJSON([])
        ElementStore.dispatch({ type: 'set_data', data: [] });
        dispatch(getSurveyClear({}))
 
         
        
        }
        
        setIsLoading(false);
      }
    }, [createSurveyData]);

    useEffect(() => {
        if (infoModal) {
            setTimeout(() => {
                setInfoModal(false)
                setShowInfoModalMsg('')
            }, 5000)
        }
    }, [infoModal])

    const addLinkFontAwesome = () => {
        var link = document.createElement('link');
        link.id = 'id2';
        link.rel = 'stylesheet';
        link.href = "https://use.fontawesome.com/releases/v5.13.0/css/all.css";
        document.head.appendChild(link);
    }

    const handleSubmitData = evt => {
        console.log('event', evt)
        if (evt.origin === CONFIG.API_URL_BROKER_ADMIN) {
            let dataObj = evt.data;
            if (typeof dataObj === 'object') {
                if (dataObj && dataObj.clicked === 'save') {
                    // console.log('NOTES CLICKED', dataObj, evt)
                    // dataObj.url = evt.origin;
                    // fetchDataFromIframe(dataObj);
                    if (!_.isEmpty(formJSON)) {
                        console.log('Submitting survey', formJSON);
                        submitSurvey();
                    } else {
                        console.log(formJSON);
                        console.log('form is empty')
                        window.parent.postMessage({
                            status: false,
                            message: 'Form is empty'
                        }, CONFIG.API_URL_BROKER_ADMIN)
                    }
                }
            } else {
                console.log('Invalid data');
            }
        }

    }

    const handleSaveButtonClicked = (event) => {
        console.log(event)
        let dataObj = typeof event.data === 'object' ? event.data : JSON.parse(event.data);
        if (dataObj) {
            // if (!_.isEmpty(formJSON)) {
            //     console.log('Submitting Survey')
            //     submitSurvey()
            // } else {
            //     console.log('Form is empty')
            //     window.parent.postMessage({
            //         status: false,
            //         message: 'form is empty'
            //     }, CONFIG.API_URL_BROKER_ADMIN)
            // }
        }
    }

    const submitSurvey = () => {
        if (enableBtn) {
            setIsLoading(true)
            // const token = isMobile ? localStorage.getItem(SessionKeys.API_TOKEN) : localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            const token =  localStorage.getItem(SessionKeys.API_TOKEN_BROKER)
            // const token = "77c7923b-7be6-4520-bb08-d5bdcffe7c6c"
            console.log("formdata",formJSON)
            // console.log("title",surveyTitle)
            // console.log("token",surveyTitle)
            const postData = {
                token: token,
                title:surveyTitle,
                formJSON:formJSON
            };
            console.log("postData",postData)
            dispatch(getSurvey({
                module: 'add-survey',
                postData
            }))
        }
    }

    const renderAlertCard = () => {
        return (
            <div
                className={`cal-alert alert-card d-flex justify-content-center ${infoModal ? "" : "d-none"
                    }`}
            >
                <div className="shop-cart">
                    <div className="shop-info justify-content-center">
                        <p className="m-0">{showInfoModalMsg}</p>
                    </div>
                    <div className="view-cart-icon">
                        <i
                            className="fa fa-times cursor-pointer"
                            aria-hidden="true"
                            onClick={() => {
                                setInfoModal(false);
                                setShowInfoModalMsg("");
                            }}
                        ></i>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            <Loader start={isLoading} />
            <section className="my-credit-points learningpaths builder-form">
                <div className="container position-relative">
                    {renderAlertCard()}
                    <div className="row">
                        <div className="col-md-12 mb-5 profile-left-sec ">
                            {/* <div className="search_heading mt-2">
                                <p className="lable-heading_search">Create Survey</p>
                            </div> */}
                            <div className="ddcdfe">
                                <div className="w-30">
                                    <div className="mb-3">
                                        <label htmlFor="surveyTitle" className="lable-heading_search">
                                            Survey Title
                                        </label>
                                        <input
                                            type="text"
                                            id="surveyTitle"
                                            className="form-control"
                                            placeholder="Enter survey title"
                                            value={surveyTitle}
                                            onChange={(e) => {
                                                console.log("Input Value:", e.target.value); // Debugging
                                                setSurveyTitle(e.target.value);
                                                setEnableBtn(e.target.value.trim() !== "");
                                            }}
                                        />
                                    </div>
                                    <DndProvider backend={HTML5Backend}>
                                        <ReactFormBuilder
                                            url=""
                                            toolbarItems={items}
                                            saveUrl=""
                                            saveAlways={false}
                                            onChange={(data) => { console.log(data) }}
                                            action_name="Submit"
                                        // renderEditForm={props => <FormElementsEdit {...props} />}
                                        />
                                    </DndProvider>
                                    <div className="d-flex justify-content-end gap-2 mt-3">
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-primary  setup-button w-100"
                                                onClick={submitSurvey}
                                                disabled={!enableBtn}
                                            >Generate Survey</button>
                                        </div>
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-primary  setup-button w-100"
                                                onClick={() => {
                                                    window.parent.postMessage(JSON.stringify({
                                                        status: true,
                                                        message: '',
                                                        cancelClicked: true
                                                    }), CONFIG.API_URL_BROKER_ADMIN)
                                                }}
                                            >Cancel</button>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default FormBuilderSection